"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeById = void 0;
function removeById(array, id) {
    return array.filter((other) => other.id !== id);
}
exports.removeById = removeById;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVtb3ZlQnlJZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9yZW1vdmVCeUlkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFVBQVUsQ0FDeEIsS0FBVSxFQUNWLEVBQVc7SUFFWCxPQUFPLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFDbEQsQ0FBQztBQUxELGdDQUtDIn0=